import React, { ChangeEvent } from "react";
import ErrorMessage from "../ErrorMessage";
import { ErrorType } from "../../../types/common-type";
import "./formfield.css";

// ─── Types ────────────────────────────────────────────────────────────────────
export type FieldType =
  | "text"
  | "email"
  | "password"
  | "number"
  | "url"
  | "tel"
  | "textarea"
  | "date";

export interface FormFieldProps<T extends Record<string, any>> {
  label: string;
  name: keyof T;
  data: T;
  dateChange?: <K extends keyof T>(field: K, value: string) => void;
  onChange: (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
  ) => void;
  errors?: ErrorType | null;
  type?: FieldType;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  colClass?: string;
  rows?: number;
  maxLength?: number;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
}

// ─── Component ────────────────────────────────────────────────────────────────

function InputField<T extends Record<string, any>>({
  label,
  name = "",
  data,
  onChange,
  errors = {},
  type = "text",
  required = false,
  placeholder,
  disabled = false,
  className = "",
  colClass = "col-6 col-md-4",
  rows = 3,
  maxLength,
  inputMode,
}: FormFieldProps<T>) {
  const value = (data[name] as string) ?? "";
  const error = errors && errors[name as string];
  const isInvalid = Boolean(error);
  const nameStr = name as string; 
  const controlClass = `form-control formfield-control ${className || ""} ${
    isInvalid ? "is-invalid" : ""
  }`.trim();

  const renderControl = () => {
    if (type === "textarea") {
      return (
        <textarea
          className={`${controlClass} formfield-textarea`}
          name={nameStr}
          value={value}
          onChange={onChange}
          placeholder={placeholder || label}
          disabled={disabled}
          rows={rows}
          maxLength={maxLength}
          aria-invalid={isInvalid}
        />
      );
    }

    return (
      <input
        type={type}
        className={controlClass}
        name={nameStr}
        value={value}
        onChange={(e) => {
          if (inputMode === "numeric") {
            let value_numeric = e.target.value.replace(/\D/g, "");
            e.target.value = !!maxLength
              ? value_numeric?.slice(0, maxLength)
              : value_numeric;
            onChange(e as React.ChangeEvent<HTMLInputElement>);
            return;
          }
          onChange(e);
        }}
        placeholder={`Enter ${placeholder || label}`}
        disabled={disabled}
        maxLength={maxLength}
        inputMode={inputMode}
        aria-invalid={isInvalid}
      />
    );
  };

  return (
    <div className={`${colClass} mb-3 ${className}`}>
      {label && (
        <label className="form-label formfield-label">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      {renderControl()}
      {error && <ErrorMessage message={error} classStyle="pt-1" />}
    </div>
  );
}

export default InputField;

// import React, { ChangeEvent } from "react";
// import ErrorMessage from "../ErrorMessage";
// import { DatePicker } from "antd";
// import dayjs from "dayjs";
// import { ErrorType } from "../../../types/common-type";

// // ─── Types ────────────────────────────────────────────────────────────────────
// export type FieldType =
//   | "text"
//   | "email"
//   | "password"
//   | "number"
//   | "url"
//   | "tel"
//   | "textarea"
//   | "date";

// export interface FormFieldProps<T extends Record<string, any>> {
//   label: string;
//   name: keyof T;
//   data: T;
//   dateChange?: <K extends keyof T>(field: K, value: string) => void;
//   onChange: (
//     e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
//   ) => void;
//   // errors?: Partial<Record<keyof T, string>>;
//   errors?: ErrorType | null;
//   type?: FieldType;
//   required?: boolean;
//   placeholder?: string;
//   disabled?: boolean;
//   className?: string;
//   colClass?: string;
//   rows?: number;
//   maxLength?: number;
//   inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
// }

// // ─── Component ────────────────────────────────────────────────────────────────

// function InputField<T extends Record<string, any>>({
//   label,
//   name = "",
//   data,
//   onChange,
//   errors = {},
//   type = "text",
//   required = false,
//   placeholder,
//   disabled = false,
//   className = "",
//   colClass = "col-6 col-md-4",
//   rows = 3,
//   maxLength,
//   inputMode,
// }: FormFieldProps<T>) {
//   const value = (data[name] as string) ?? "";
//   const error = errors && errors[name as string];
//   const isInvalid = Boolean(error);
//   const nameStr = name as string;

//   // Bootstrap validation class — appended after any custom className so
//   // "is-invalid" always wins and shows the red border/feedback styling.
//   const controlClass = `form-control ${className || ""} ${
//     isInvalid ? "is-invalid" : ""
//   }`.trim();

//   const renderControl = () => {
//     if (type === "textarea") {
//       return (
//         <textarea
//           className={controlClass}
//           name={nameStr}
//           value={value}
//           onChange={onChange}
//           placeholder={placeholder || label}
//           disabled={disabled}
//           rows={rows}
//           maxLength={maxLength}
//           aria-invalid={isInvalid}
//         />
//       );
//     }

//     return (
//       <input
//         type={type}
//         className={controlClass}
//         name={nameStr}
//         value={value}
//         onChange={(e) => {
//           if (inputMode === "numeric") {
//             let value_numeric = e.target.value.replace(/\D/g, "");
//             e.target.value = !!maxLength
//               ? value_numeric?.slice(0, maxLength)
//               : value_numeric;
//             onChange(e as React.ChangeEvent<HTMLInputElement>);
//             return;
//           }
//           onChange(e);
//         }}
//         placeholder={placeholder || label}
//         disabled={disabled}
//         maxLength={maxLength}
//         inputMode={inputMode}
//         aria-invalid={isInvalid}
//       />
//     );
//   };

//   return (
//     <div className={`${colClass} mb-3 ${className}`}>
//       {label && (
//         <label className="form-label ">
//           {label} {required && <span className="text-danger">*</span>}
//         </label>
//       )}
//       {renderControl()}
//       {error && <ErrorMessage message={error} classStyle="pt-1" />}
//     </div>
//   );
// }

// export default InputField;

// import React, { ChangeEvent } from "react";
// import ErrorMessage from "../ErrorMessage";
// import { DatePicker } from "antd";
// import dayjs from "dayjs";
// import { ErrorType } from "../../../types/common-type";

// // ─── Types ────────────────────────────────────────────────────────────────────
// export type FieldType =
//   | "text"
//   | "email"
//   | "password"
//   | "number"
//   | "url"
//   | "tel"
//   | "textarea"
//   | "date";

// export interface FormFieldProps<T extends Record<string, any>> {
//   label: string;
//   name: keyof T;
//   data: T;
//   dateChange?: <K extends keyof T>(field: K, value: string) => void;
//   onChange: (
//     e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
//   ) => void;
//   // errors?: Partial<Record<keyof T, string>>;
//   errors?: ErrorType | null;
//   type?: FieldType;
//   required?: boolean;
//   placeholder?: string;
//   disabled?: boolean;
//   className?: string;
//   colClass?: string;
//   rows?: number;
//   maxLength?: number;
//   inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
// }

// // ─── Component ────────────────────────────────────────────────────────────────

// function InputField<T extends Record<string, any>>({
//   label,
//   name = "",
//   data,
//   onChange,
//   errors = {},
//   type = "text",
//   required = false,
//   placeholder,
//   disabled = false,
//   className = "",
//   colClass = "col-6 col-md-4",
//   rows = 3,
//   maxLength,
//   inputMode,
// }: FormFieldProps<T>) {
//   const value = (data[name] as string) ?? "";
//   const error = errors && errors[name as string];
//   const isInvalid = Boolean(error);
//   // const inputClass = `form-control ${isInvalid ? " is-invalid" : ""}`;
//   const nameStr = name as string;

//   const renderControl = () => {
//     if (type === "textarea") {
//       return (
//         <textarea
//           // className={inputClass}
//           className={`form-control ${className || ""}`}
//           name={nameStr}
//           value={value}
//           onChange={onChange}
//           placeholder={placeholder || label}
//           disabled={disabled}
//           rows={rows}
//           maxLength={maxLength}
//         />
//       );
//     }

//     return (
//       <input
//         type={type}
//         // className={inputClass}
//         className={`form-control ${className || ""}`}
//         name={nameStr}
//         value={value}
//         onChange={(e) => {
//           if (inputMode === "numeric") {
//             let value_numeric = e.target.value.replace(/\D/g, "");
//             e.target.value = !!maxLength
//               ? value_numeric?.slice(0, maxLength)
//               : value_numeric;
//             onChange(e as React.ChangeEvent<HTMLInputElement>);
//             return;
//           }
//           onChange(e);
//         }}
//         placeholder={placeholder || label}
//         disabled={disabled}
//         maxLength={maxLength}
//         inputMode={inputMode}
//       />
//     );
//   };

//   return (
//     <div className={`${colClass} mb-3 ${className}`}>
//       {label && (
//         <label className="form-label ">
//           {label} {required && <span className="text-danger">*</span>}
//         </label>
//       )}
//       {renderControl()}
//       {error && <ErrorMessage message={error} classStyle="pt-1" />}
//     </div>
//   );
// }

// export default InputField;
